import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartCtx = createContext(null);

function load() {
  try { return JSON.parse(localStorage.getItem('aegis_cart') || '[]'); } catch { return []; }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);

  useEffect(() => { localStorage.setItem('aegis_cart', JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const copy = [...prev]; copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qty }; return copy;
      }
      return [...prev, {
        product_id: product.id, slug: product.slug, name: product.name,
        price: Number(product.price || 0), image: product.image || null, quantity: qty,
      }];
    });
  };
  const update = (product_id, qty) => setItems((prev) => prev.map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, qty) } : i)));
  const remove = (product_id) => setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(() => ({ items, add, update, remove, clear, count, total }), [items, count, total]);
  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => {
  const c = useContext(CartCtx);
  if (!c) throw new Error('CartProvider missing');
  return c;
};
